module.exports = __webpack_public_path__ + "img/two.b13d5283.jpeg";